"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = _interopRequireDefault(require("immutable"));

var _enviro = _interopRequireDefault(require("enviro"));

var _I18n = _interopRequireDefault(require("I18n"));

var _formatters = require("ecosystem-marketplace-core/utils/formatters");

var _Reviewability = require("../constants/Reviewability");

var defaults = {
  isPublic: false,
  installedAt: 0,
  uninstalledAt: 0,
  portalReviewsCount: 0,
  userAlreadyReviewed: null,
  userOnProviderPortal: null,
  testPortal: null,
  maxPortalReviews: 0,
  maxMillisAfterUninstall: 0
};

var AppReviewability = /*#__PURE__*/function (_Immutable$Record) {
  (0, _inherits2.default)(AppReviewability, _Immutable$Record);

  function AppReviewability(data) {
    (0, _classCallCheck2.default)(this, AppReviewability);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AppReviewability).call(this, (0, _formatters.cleanObject)(data)));
  }

  (0, _createClass2.default)(AppReviewability, [{
    key: "getUnreviewableReason",
    value: function getUnreviewableReason() {
      var isPublic = this.isPublic,
          installedAt = this.installedAt,
          uninstalledAt = this.uninstalledAt,
          portalReviewsCount = this.portalReviewsCount,
          userAlreadyReviewed = this.userAlreadyReviewed,
          userOnProviderPortal = this.userOnProviderPortal,
          testPortal = this.testPortal,
          maxPortalReviews = this.maxPortalReviews,
          maxMillisAfterUninstall = this.maxMillisAfterUninstall;
      var withinUninstallWindow = !uninstalledAt || _I18n.default.moment().diff(_I18n.default.moment(uninstalledAt)) < maxMillisAfterUninstall;
      var withinReviewLimit = portalReviewsCount < maxPortalReviews;

      var isQa = _enviro.default.isQa();

      if (isPublic) {
        return _Reviewability.UnreviewableReasons.PUBLIC_USER;
      } else if (!installedAt && !isQa) {
        return _Reviewability.UnreviewableReasons.NOT_INSTALLED;
      } else if (!withinUninstallWindow && !isQa) {
        return _Reviewability.UnreviewableReasons.UNINSTALLED;
      } else if (!withinReviewLimit && !isQa) {
        return _Reviewability.UnreviewableReasons.LIMIT_REACHED;
      } else if (userAlreadyReviewed) {
        return _Reviewability.UnreviewableReasons.ALREADY_REVIEWED;
      } else if (userOnProviderPortal && !isQa) {
        return _Reviewability.UnreviewableReasons.PROVIDER_USER;
      } else if (testPortal) {
        return _Reviewability.UnreviewableReasons.TEST_PORTAL_USER;
      } else {
        return false;
      }
    }
  }, {
    key: "isReviewable",
    value: function isReviewable() {
      return !this.getUnreviewableReason();
    }
  }]);
  return AppReviewability;
}(_immutable.default.Record(defaults));

exports.default = AppReviewability;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/records/AppReviewability.js
// module id = 136
// module chunks = 209 210 211 212